import { useMemo } from "react";

import { ContactFragment } from "@/__generated__/graphql";
import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

import {
  contactToThreadContext,
  ContactsViewThreadActions,
} from "./ContactsViewThreadActions";
import { usePrepareDataViewThread } from "../shared/dataViewThread.tools";

export function ContactsView() {
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const {
    columns,
    rows,
    loading,
    totalCount,
    deleteNodeButtonProps,
    loadNext,
    networkStatus,
  } = useConnectionSetup({ appView: "contacts" });

  const contactRows = rows as ContactFragment[];
  const prepareThread = usePrepareDataViewThread(
    contactRows,
    contactToThreadContext,
  );

  const onCheckedRowsExtraActions = useMemo(
    () => (props: { checkedRowIds: string[]; clearSelection: () => void }) => (
      <ContactsViewThreadActions {...props} onPrepareThread={prepareThread} />
    ),
    [prepareThread],
  );

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={contactRows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsExtraActions={onCheckedRowsExtraActions}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-ContactObject",
        })
      }
      placeholderRow={Objects.ContactObject.placeholder}
      emptyState={{
        ReactIcon: Objects.ContactObject.ReactIcon,
        title: "No contacts yet",
        description:
          "Customers and vendors live here — the names transactions and documents are matched against.",
        actionLabel: "New contact",
      }}
    />
  );
}
